export enum BuyingCenterVerificationTypeEnum {
  MACHINE_VERIFIED = 'MACHINE_VERIFIED',
  HUMAN_VERIFIED = 'HUMAN_VERIFIED',
  EMAIL_VERIFIED = 'EMAIL_VERIFIED',
  OUTDATED = 'OUTDATED',
}
